import { render, staticRenderFns } from "./sesionExpiradaModal.vue?vue&type=template&id=2dd02967&scoped=true"
import script from "./sesionExpiradaModal.vue?vue&type=script&lang=js"
export * from "./sesionExpiradaModal.vue?vue&type=script&lang=js"
import style0 from "./sesionExpiradaModal.vue?vue&type=style&index=0&id=2dd02967&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd02967",
  null
  
)

export default component.exports